document.addEventListener("DOMContentLoaded", function () {
  function detectBrowser() {
    const userAgent = navigator.userAgent;

    let browserName = "";

    if (userAgent.includes("Firefox")) {
      browserName = "Firefox";
    } else if (userAgent.includes("Edg")) {
      browserName = "Microsoft Edge";
    } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browserName = "Google Chrome";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browserName = "Safari";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      browserName = "Opera";
    } else if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
      browserName = "Internet Explorer";
    }

    if (browserName === "Safari") {
      const iframe = document.getElementById("vimeo-player");
      if (iframe) {
        const currentSrc = iframe.src;

        if (!currentSrc.includes("mute=1")) {
          iframe.src = currentSrc + "&mute=1";
        }
      }
    }
  }

  detectBrowser();
});
